class StyleCardsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-style-cards-track]');
    this.viewport = this.querySelector('[data-style-cards-viewport]');
    this.cards = Array.from(this.querySelectorAll('[data-style-card]'));
    this.prevButton = this.querySelector('[data-style-cards-prev]');
    this.nextButton = this.querySelector('[data-style-cards-next]');
    this.progress = this.querySelector('[data-style-cards-progress]');
    this.index = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = Number(this.dataset.interval) || 4000;

    if (!this.track || this.cards.length === 0) return;

    this.onPrev = () => this.goTo(this.index - 1, true);
    this.onNext = () => this.goTo(this.index + 1, true);
    this.onResize = () => this.update(true);

    this.prevButton?.addEventListener('click', this.onPrev);
    this.nextButton?.addEventListener('click', this.onNext);
    window.addEventListener('resize', this.onResize);
    this.addEventListener('mouseenter', () => this.stopAuto());
    this.addEventListener('mouseleave', () => this.startAuto());
    this.addEventListener('focusin', () => this.stopAuto());
    this.addEventListener('focusout', () => this.startAuto());

    this.update(true);
    this.startAuto();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.onPrev);
    this.nextButton?.removeEventListener('click', this.onNext);
    window.removeEventListener('resize', this.onResize);
    this.stopAuto();
  }

  getVisibleCount() {
    if (window.innerWidth < 750) return 1;
    if (window.innerWidth < 990) return 2;
    return 4;
  }

  getMaxIndex() {
    return Math.max(this.cards.length - this.getVisibleCount(), 0);
  }

  goTo(nextIndex, userInitiated = false) {
    const maxIndex = this.getMaxIndex();
    if (nextIndex > maxIndex) nextIndex = 0;
    if (nextIndex < 0) nextIndex = maxIndex;
    this.index = nextIndex;
    this.update();
    if (userInitiated) this.restartAuto();
  }

  update(skipAnimation = false) {
    const visible = this.getVisibleCount();
    const maxIndex = this.getMaxIndex();
    this.index = Math.min(this.index, maxIndex);
    const currentCard = this.cards[this.index];
    const offset = currentCard ? currentCard.offsetLeft : 0;

    if (skipAnimation) {
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      requestAnimationFrame(() => {
        this.track.style.transition = '';
      });
    } else {
      this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    }

    if (this.prevButton) this.prevButton.disabled = this.cards.length <= visible;
    if (this.nextButton) this.nextButton.disabled = this.cards.length <= visible;

    if (this.progress) {
      const width = Math.min(100, (visible / this.cards.length) * 100);
      const ratio = maxIndex === 0 ? 0 : this.index / maxIndex;
      this.progress.style.width = `${width}%`;
      this.progress.style.left = `${(100 - width) * ratio}%`;
    }
  }

  startAuto() {
    this.stopAuto();
    if (!this.autoplay || this.cards.length <= this.getVisibleCount()) return;
    this.timer = window.setInterval(() => this.goTo(this.index + 1), this.interval);
  }

  stopAuto() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  restartAuto() {
    this.stopAuto();
    this.startAuto();
  }
}

if (!customElements.get('style-cards-slider')) {
  customElements.define('style-cards-slider', StyleCardsSlider);
}